<div *ngIf="!isDecline">
  <app-header></app-header>
  <div class="save__redirect">
    <div class="container-xl">
      <div
        class="msg d-flex align-items-start justify-content-center"
        [innerHTML]="'save.redirectMsg' | translate"
      ></div>
    </div>
    <div
      *ngIf="showGuestError"
      class="msg d-flex align-items-center justify-content-center"
      [innerHTML]="'save.callSessionLinkExpired' | translate"
    ></div>
  </div>
</div>
<div *ngIf="isDecline">
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</div>
<ng-template #inviteConfirmationModal let-modal>
  <div class="invite-confirmation">
    <div class="header" [innerHTML]="'common.confirmInvite' | translate"></div>
    <div class="op-p-24">
      <div
        [innerHTML]="'common.acceptInvite' | translate"
        class="d-flex justify-content-start op-mb-16"
      ></div>
      <div class="d-flex justify-content-between align-items-center op-mt-3">
        <button
          [innerHTML]="'common.cancel' | translate"
          class="op-btn cancel"
          (click)="onCancelClick()"
        ></button>
        <button
          (click)="modal.close(); confirmInvite()"
          [innerHTML]="'common.accept' | translate"
          class="op-btn op-ml-16 submit"
        ></button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Confirm Cancel Modal -->
<ng-template #confirmCancelModal let-modal>
  <div class="invite-confirmation">
    <div
      class="header"
      [innerHTML]="'common.confirmCancelTitle' | translate"
    ></div>
    <div class="op-p-24">
      <div
        class="d-flex justify-content-start op-mb-16"
        [innerHTML]="'common.confirmCancelText' | translate"
      ></div>
      <div class="d-flex justify-content-end op-mt-3">
        <button
          class="op-btn cancel"
          [innerHTML]="'common.yes' | translate"
          (click)="modal.dismiss(); redirect()"
        ></button>
        <button
          class="op-btn op-ml-16 submit"
          (click)="modal.dismiss()"
          [innerHTML]="'common.no' | translate"
        ></button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #inviteDeclineModal let-modal>
  <div class="invite-confirmation">
    <div class="header" [innerHTML]="'common.declineInvite' | translate"></div>
    <div class="op-p-24">
      <div
        [innerHTML]="'common.declineInviteText' | translate"
        class="d-flex justify-content-start op-mb-16"
      ></div>
      <div class="d-flex justify-content-between align-items-center op-mt-3">
        <button
          [innerHTML]="'common.cancel' | translate"
          class="op-btn cancel"
          (click)="onCancelClick()"
        ></button>
        <button
          (click)="modal.close(); confirmDecline()"
          [innerHTML]="'common.decline' | translate"
          class="op-btn op-ml-16 decline"
        ></button>
      </div>
    </div>
  </div>
</ng-template>
